import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import BasicHeader from '../../modules/BasicHeader';
import Footer from '../../modules/Footer';
import LoginPage from '../../pages/Login';
import RegisterPage from '../../pages/Register';
import AdminUserLicences from '../../pages/AdminUserLicences';
import ForgottenPassword from '../../pages/ForgottenPassword';
import PasswordReset from '../../pages/PasswordReset';
import Services from '../../pages/Services';
import Account from '../../pages/Account';
import MyData from '../../pages/MyData';
import ScrollToTop from '../../modules/ScrollToTop';
import AdminSearchUsers from '../../pages/AdminSearchUsers';
import AdminServiceLicences from '../../pages/AdminServiceLicences';
import AdminManageLicences from '../../pages/AdminManageLicences';
import AdminNewLicence from '../../pages/AdminNewLicence';
import AdminEditLicence from '../../pages/AdminEditLicence';
import ViewLicence from '../../pages/ViewLicence';
import NotificationSystem from '../../modules/NotificationSystem';
import AdminAuditLog from '../../pages/AdminAuditLog';
import AdminEditUser from '../../pages/AdminEditUser';
import AccountConfirmation from '../../pages/AccountConfirmation';
import ViewAccessibilityStatement from '../../pages/ViewAccessibilityStatement';
import { AuthenticatedRoute } from '../../modules/ProtectedRoutes';
import AppWrapper from '../../modules/AppWrapper';
import Authenticator from "../Authenticator";
import Support from "../Support";

import styles from './styles.scss';

export default class App extends React.Component {
    render() {
        return (
            <AppWrapper>

                <NotificationSystem/>

                <a href="#main-content" className={styles['skip-link']}>
                    Skip to main content
                </a>

                <div className={styles['content-wrapper']}>
                    <BasicHeader/>

                    <div className={styles['page-wrapper']}>
                        <Switch>
                            <ScrollToTop>
                                <Route exact path='/' component={() => <Redirect to='/services'/>}/>
                                <Route exact path='/login' component={LoginPage}/>
                                <Route exact path='/register' component={RegisterPage}/>
                                <Route exact path='/forgotten-password' component={ForgottenPassword}/>
                                <Route exact path='/reset-password' component={PasswordReset}/>
                                <Route exact path='/licences/:id' component={ViewLicence}/>
                                <Route exact path='/services/:id/licences/:licenceType' component={ViewLicence}/>
                                <Route exact path='/account-confirmation' component={AccountConfirmation}/>
                                <Route exact path='/accessibility-statement/:id'
                                       component={ViewAccessibilityStatement}/>
                                <Route exact path='/authenticator' component={Authenticator} />
                                <Route exact path='/support' component={Support} />

                                <AuthenticatedRoute exact path='/services' component={Services}/>
                                <AuthenticatedRoute exact path='/account' component={Account}/>
                                <AuthenticatedRoute exact path='/my-data' component={MyData}/>
                                <AuthenticatedRoute exact path='/admin/users' component={AdminSearchUsers}/>
                                <AuthenticatedRoute exact path='/admin/edit-user/:id' component={AdminEditUser}/>
                                <AuthenticatedRoute exact path='/admin/user-licences/:id'
                                                    component={AdminUserLicences}/>
                                <AuthenticatedRoute exact path='/admin/licences' component={AdminServiceLicences}/>
                                <AuthenticatedRoute exact path='/admin/manage-licences'
                                                    component={AdminManageLicences}/>
                                <AuthenticatedRoute exact path='/admin/new-licence' component={AdminNewLicence}/>
                                <AuthenticatedRoute exact path='/admin/edit-licence/:id'
                                                    component={AdminEditLicence}/>
                                <AuthenticatedRoute exact path='/admin/audit-logs/:id' component={AdminAuditLog}/>
                            </ScrollToTop>
                        </Switch>
                    </div>

                    <div className={styles['push']}/>
                </div>

                <Footer/>
            </AppWrapper>
        )
    }
}